import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 顧客詳細（履歴）取得
export async function getOldContract(
  id: string,
  service_plan_id: string,
  contract_version: number
) {
  try {
    const path = "oldContract";
    const params = { id, service_plan_id, contract_version };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    const detail_data: {
      [key: string]: number | string | { [key: string]: string | string[] };
    } = response.data.detail_data[0];
    return { detail_data };
  } catch (error) {
    // logout();
    return { detail_data: {} };
  }
}
